/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Users({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#Users_svg__a)" clipRule="evenodd"><path d="M6.25.9A3.6 3.6 0 1 0 8 7.647a3.6 3.6 0 1 0 0-6.293A3.6 3.6 0 0 0 6.25.9m-2.4 3.6a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0m5.178-2.29c.514.623.822 1.42.822 2.29s-.308 1.667-.822 2.29q.343.108.722.11a2.4 2.4 0 1 0-.722-4.69M2.473 15.1c-1.085 0-1.812-1.072-1.5-2.08l.127-.41C1.69 10.708 3.414 9.4 5.381 9.4h5.238c1.967 0 3.692 1.307 4.28 3.21l.128.41c.312 1.008-.415 2.08-1.5 2.08zm4.646-4.5H5.381c-1.422 0-2.696.947-3.135 2.365l-.126.41c-.087.28.122.525.353.525h7.554c.231 0 .44-.245.353-.526l-.126-.41C9.814 11.548 8.54 10.6 7.119 10.6m4.43 3.3c.072-.28.07-.583-.022-.88l-.127-.41a4.6 4.6 0 0 0-1.256-2.01h.475c1.422 0 2.696.947 3.135 2.365l.126.41c.087.28-.122.525-.354.525z" /></g><defs><clipPath id="Users_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;